var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPawesomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1076.24 512.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_pawesomer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pawesomer"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.24,
    width: 1075.24,
    height: 506.78
  }), /*#__PURE__*/React.createElement("g", {
    id: "pawesomer_text",
    "data-name": "pawesomer text"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.19,340.05l.68,36.74L2.4,375.94l.35-225.76a190.82,190.82,0,0,1,28.36-2.39h3.25q17.43.51,29.22,6,28,11.11,28.72,72.46Q90.76,269,68.54,284.85,51.62,295.78,34.7,295.27Zm.51-163-.17,85.45q12-1,17.26-6,6.49-6.15,7.69-33.16-.16-25.8-2.73-33.49Q49.57,177.19,34.7,177Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163,147.1,194.73,372l-23.07,1-4.79-32.13-28.2.86-3.42,37.59-32.13.18,27.69-228.84ZM142.26,308.94l20.17.18-12.31-76.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.57,288.09l7-141.67h31.95L321.27,377.3l-31.1-.17L270.52,271.86,253.6,377.13l-33.33-.51-11.11-229,30.25-2.23L244,286l14-108.17,27.52-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M394.23,265.71l-.69,73.65,40.85.52L433.19,377l-72.46-.85,3.42-228,69.55.51L434.9,184l-39.48.51-.68,44.78,31.79.51-1,36.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M467.18,178.21q7.51-28.71,39.48-30.76v-.18q28.53,1.2,36.57,30.42,6.15,21.54,7.69,48.71l-31.79,1q-.51-10.77-2.22-23.59-2.4-20.33-9.4-21.19v.17q-9.74,1.37-12.13,21.36-3.42,16.24,18.71,38.71t30.51,37a80.79,80.79,0,0,1,6.83,32.81,107.85,107.85,0,0,1-6.15,34.7q-7.35,29.06-36.57,31.44V379q-31.27-.86-39.82-30.25a291.35,291.35,0,0,1-8.55-43.4l31.45-4.28q1.53,8.39,3.25,21,2.55,20.52,12.3,21.2,7-1.71,9.23-21.71,4.95-22.21-15.64-42.21t-28.28-36.23q-12.13-21.19-9.23-47.68A155.24,155.24,0,0,1,467.18,178.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M672.75,263.49q0,55.71-8,85.1t-39.31,30.59V379q-32-2.22-39.65-31.1t-7.69-84.77h.17q0-55.53,7.69-84.25,7.7-29.05,39.65-30.93v-.17q31.27,1,39.31,30.42t8,85.28Zm-34.27-59q-2.47-20.34-12-21.2v.17q-9.91,1.38-12.31,21.37t-2.39,58.44q0,38.46,2.39,58.54t12.13,21.45v.17q9.75-.86,12.14-21.2Q641,301.95,641,263.49,641,224.87,638.48,204.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M733.57,257l-3.42,121h-32l7.69-231.06,30.25.17v.17h8.38l19,115.36,17.6-115.36,29-.17,8.89-.34,8.54,230L797.31,379l-4.44-117.75-14.35,85.28L751,349.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M890.26,265.71l-.68,73.65,40.84.52L929.23,377l-72.46-.85,3.41-228,69.56.51,1.2,35.38-39.48.51-.69,44.78,31.79.51-1,36.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1002.18,294.93a42.61,42.61,0,0,1-7.69.34L994,340.05l.68,36.74-32.47-.85.34-225.76a191,191,0,0,1,28.37-2.39q20.69.51,28.88,2.39,29.57,8.2,32.3,76-1.36,40.34-21.36,56.74l29,91.77-31.78,4.1ZM994.49,177l-.17,85.45q12-1,17.26-6,6.49-6.15,7.69-33.16-.16-25.8-2.73-33.49Q1011.41,173.6,994.49,177Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPawesomer);
export default __webpack_public_path__ + "static/media/logo_pawesomer.338a042ed21cbe5d503d6e75361998d2.svg";
export { ForwardRef as ReactComponent };